import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { homeApi } from '../api/home';
import BottomNav from '../components/BottomNav';
import Icon from '../components/Icon';
import './Mine.css';

const Mine = () => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userInfo, setUserInfo] = useState({
    nickname: '',
    avatar: '',
    lv: 0,
    city: '',
    guanzhu: 0,
    fansi: 0,
    zhan: 0,
    medal_list: []
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkLoginStatus();
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      fetchUserInfo();
    }
  }, [isLoggedIn]);

  const checkLoginStatus = () => {
    const token = localStorage.getItem('token');
    setIsLoggedIn(!!token);
    if (!token) {
      setLoading(false);
    }
  };

  const fetchUserInfo = async () => {
    try {
      const result = await homeApi.getUserInfo();
      if (result.code === 200) {
        setUserInfo(result.data.userinfo);
      }
    } catch (error) {
      console.error('获取用户信息失败:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    if (window.confirm('确认退出账号吗?')) {
      localStorage.removeItem('token');
      setIsLoggedIn(false);
      navigate('/');
    }
  };

  const navigateTo = (path, needLogin = false) => {
    if (needLogin && !isLoggedIn) {
      navigate('/login');
      return;
    }
    navigate(path);
  };

  const formatTime = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp * 1000);
    return date.toLocaleString('zh-CN');
  };

  if (loading) {
    return <div className="loading">加载中...</div>;
  }

  return (
    <div className="mine-page">
      <div className="top-background">
        <div className="background-image"></div>
      </div>

      <div className="mine-container">
        <div className="user-section">
          <div className="user-info-row" onClick={() => navigateTo('/set', true)}>
            <div className="user-info-left">
              <div className="avatar-wrapper">
                <div className="avatar">
                  <div
                    className="avatar-image"
                    style={{ backgroundImage: `url(${userInfo.avatar || '/avatar.jpg'})` }}
                  ></div>
                </div>
              </div>
              <div className="user-details">
                <div className="user-name-row">
                  <span className="nickname">{userInfo.nickname || '未登录'}</span>
                  {isLoggedIn && userInfo.lv > 0 && (
                    <span className="lv-badge">LV {userInfo.lv}</span>
                  )}
                  {isLoggedIn && userInfo.medal_list && userInfo.medal_list.map((medal, index) => (
                    <img
                      key={index}
                      src={medal.image}
                      alt="medal"
                      className="medal"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigateTo(`/medal?id=${medal.id}`, false);
                      }}
                    />
                  ))}
                </div>
                <div className="user-location">
                  {isLoggedIn ? (
                    <span>IP属地: {userInfo.city || '未知'}</span>
                  ) : (
                    <div className="login-prompt" onClick={() => navigateTo('/login')}>
                      点击登录
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="set-icon-wrapper" onClick={(e) => {
          e.stopPropagation();
          navigateTo('/set', true);
        }}>
          <Icon type="ic_edit" className="set-icon" />
        </div>
          </div>

          <div className="stats-row">
            <div className="stat-item" onClick={() => navigateTo('/fans/follow', true)}>
              <div className="stat-value">{userInfo.guanzhu || 0}</div>
              <div className="stat-label">我关注的</div>
            </div>
            <div className="stat-item" onClick={() => navigateTo('/fans/fans', true)}>
              <div className="stat-value">{userInfo.fansi || 0}</div>
              <div className="stat-label">我的粉丝</div>
            </div>
            <div className="stat-item" onClick={() => navigateTo('/my-star', true)}>
              <div className="stat-value">{userInfo.zhan || 0}</div>
              <div className="stat-label">我的获赞</div>
            </div>
          </div>
        </div>

        <div className="menu-section">
          <div className="menu-row">
            <div className="menu-item" onClick={() => navigateTo('/my-group', true)}>
              <div className="menu-icon-wrapper">
                <Icon type="ic_box" className="menu-icon" />
              </div>
              <div className="menu-text">我的圈子</div>
            </div>
            <div className="menu-item" onClick={() => navigateTo('/my-msg', true)}>
              <div className="menu-icon-wrapper">
                <Icon type="qunliao" className="menu-icon" />
              </div>
              <div className="menu-text">消息通知</div>
            </div>
            <div className="menu-item" onClick={() => navigateTo('/blogger-other', true)}>
              <div className="menu-icon-wrapper">
                <Icon type="ic_user" className="menu-icon" />
              </div>
              <div className="menu-text">我的主页</div>
            </div>
            <div className="menu-item" onClick={() => navigateTo('/my-like-posts', true)}>
              <div className="menu-icon-wrapper">
                <Icon type="ic_Like" className="menu-icon" />
              </div>
              <div className="menu-text">我点赞的</div>
            </div>
          </div>

          {isLoggedIn && (
            <div className="logout-section">
              <button className="logout-btn" onClick={handleLogout}>
                退出登录
              </button>
            </div>
          )}
        </div>
      </div>

      <BottomNav activeTab="profile" />
    </div>
  );
};

export default Mine;
